import { Component, ViewEncapsulation } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { combineLatest, map } from 'rxjs';

import { TenantBrandingService } from '../../tenant/tenant-branding.service';
import { TenantPublicContentService } from '../../tenant/tenant-public-content.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  readonly viewModel$ = combineLatest([
    this.tenantBranding.branding$,
    this.tenantContent.content$,
  ]).pipe(
    map(([branding, content]) => ({ branding, footer: content.footer }))
  );

  constructor(
    private tenantBranding: TenantBrandingService,
    private tenantContent: TenantPublicContentService,
  ) {}
}

